module.exports = __webpack_public_path__ + "static/media/search@3x.93c28de6.png";